import React from 'react';
import { mui } from '~/tools/mui';
import { jss } from '~/tools/jss';
import { layout } from '~/tools/layout';

type TooltipPlacement =
  | 'bottom-end'
  | 'bottom-start'
  | 'bottom'
  | 'left-end'
  | 'left-start'
  | 'left'
  | 'right-end'
  | 'right-start'
  | 'right'
  | 'top-end'
  | 'top-start'
  | 'top';

type HelpTooltipProps = {
  title: string;
  placement?: TooltipPlacement;
  className?: string;
};

const useStyles = jss.makeStyles((theme) => ({
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: layout.pxToRem(20),
    height: layout.pxToRem(20),
    marginLeft: '0.5rem',
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontSize: layout.pxToRem(12),
    fontWeight: 700,
    lineHeight: 1,
    userSelect: 'none',
    verticalAlign: 'middle',
  },
}));

export const HelpTooltip = ({ title, placement = 'top', className }: HelpTooltipProps) => {
  const styles = useStyles();
  return (
    <mui.Tooltip title={title} placement={placement} disableInteractive>
      <span className={jss.combineStyles(styles.badge, className)} aria-hidden="true">
        ?
      </span>
    </mui.Tooltip>
  );
};

export default HelpTooltip;
